import React from 'react'
import { createStyles, Typography, withStyles } from '@material-ui/core'
import { flexBreakpoint } from '../Home/Features/styles'

const styles = (theme) => {
  return createStyles({
    item: {
      borderRadius: '1.75rem',
      listStyle: 'none',
      backgroundColor: 'white',
      padding: '3.1875rem 2.25rem 1.375rem',
      textAlign: 'center',
      margin: '1rem 0',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      [theme.breakpoints.up(flexBreakpoint)]: {
        flexBasis: 'calc(50% - 1rem)',
        marginBottom: '4.3125rem',
      },
      [theme.breakpoints.up('md')]: {
        flexBasis: 'calc(33% - 1rem)',
      },
      boxShadow: '0 0.3125rem 1rem rgba(0, 0, 0, 0.1)',
      transition: 'transform 0.5s',
      '&:hover': {
        transform: 'scale(1.1)',
      },
    },
    image: {
      marginBottom: '1.8919rem',
      maxHeight: '11.5625rem',
    },
    body: {},
    title: {
      marginBottom: '0.4375rem',
    },
  })
}

const Feature = ({ classes, src, alt, title, children }) => {
  return (
    <li className={classes.item}>
      <img src={src} alt={alt} className={classes.image} />
      <div className={classes.body}>
        <Typography className={classes.title} variant="h3">
          {title}
        </Typography>
        <Typography>{children}</Typography>
      </div>
    </li>
  )
}

export default withStyles(styles)(Feature)
